import { type ParticipantLoginResponse } from "@/api-v3/model/participantLoginResponse";

import { type Token } from "./types";

/** The session the app stores after a participant logs in. */
export const buildTokenData = (
  loginResponse: ParticipantLoginResponse
): Token => ({
  access_token: loginResponse.access_token ?? "",
  refresh_token: loginResponse.refresh_token,
  requiresPinChange: loginResponse.account.pin_expires_at != null,
  isTaxCompliant: loginResponse.account.is_tax_compliant ?? null,
  countryCode: loginResponse.account.country_code ?? null,
  participantId: loginResponse.account.id ?? null,
  currency: loginResponse.account.currencies?.[0] ?? null,
});
